import type { CellPredicate, CellPredicateOp } from '../../types/panelConfig';

type AgRuleFn = (params: { value: unknown }) => boolean;
const OPS: readonly CellPredicateOp[] = ['lt', 'lte', 'gt', 'gte', 'eq', 'neq'];

function compare(op: CellPredicateOp, cellValue: unknown, threshold: number | string): boolean {
  if (cellValue == null) return false;

  const n = Number(cellValue);
  const t = Number(threshold);
  const numericBoth = !Number.isNaN(n) && !Number.isNaN(t);

  switch (op) {
    case 'lt':  return numericBoth ? n <  t : false;
    case 'lte': return numericBoth ? n <= t : false;
    case 'gt':  return numericBoth ? n >  t : false;
    case 'gte': return numericBoth ? n >= t : false;
    case 'eq':  return numericBoth ? n === t : String(cellValue) === String(threshold);
    case 'neq': return numericBoth ? n !== t : String(cellValue) !== String(threshold);
  }
}

export function buildCellClassRules(
  rules: Record<string, CellPredicate>,
): Record<string, AgRuleFn> {
  const out: Record<string, AgRuleFn> = {};
  for (const [className, predicate] of Object.entries(rules)) {
    if (!OPS.includes(predicate.op)) {
      throw new Error(`unknown op: ${predicate.op}`);
    }
    const captured = predicate;
    out[className] = (params) => compare(captured.op, params.value, captured.value);
  }
  return out;
}
